module.exports = __webpack_public_path__ + "static/fetch-ruffcut-helga-df6c6a1e01189832cddd783a81fc9837.jpg";